import vueMediumEditor from 'vue2-medium-editor'

export default vueMediumEditor.MediumEditor.extensions.form.extend({
  /* Anchor Form Options */

  notes: [],
  references: [],
  /* customClassOption: [string]  (previously options.anchorButton + options.anchorButtonClass)
    * Custom class name the user can optionally have added to their created links (ie 'button').
    * If passed as a non-empty string, a checkbox will be displayed allowing the user to choose
    * whether to have the class added to the created link or not.
    */
  customClassOption: null,

  /* customClassOptionText: [string]
    * text to be shown in the checkbox when the __customClassOption__ is being used.
    */
  customClassOptionText: 'Button',

  /* linkValidation: [boolean]  (previously options.checkLinkFormat)
    * enables/disables check for common URL protocols on anchor links.
    */
  linkValidation: false,

  /* placeholderText: [string]  (previously options.anchorInputPlaceholder)
    * text to be shown as placeholder of the anchor input.
    */
  placeholderText: 'Paste or type a link',

  /* targetCheckbox: [boolean]  (previously options.anchorTarget)
    * enables/disables displaying a "Open in new window" checkbox, which when checked
    * changes the `target` attribute of the created link.
    */
  targetCheckbox: false,

  /* targetCheckboxText: [string]  (previously options.anchorInputCheckboxLabel)
    * text to be shown in the checkbox enabled via the __targetCheckbox__ option.
    */
  targetCheckboxText: 'Open in new window',

  // Options for the Button base class
  name: 'referenceandfootnote',
  action: 'createLink',
  aria: 'link',
  tagNames: ['a'],
  contentDefault: '<b>#</b>',
  contentFA: '<i class="fa fa-link"></i>',

  init: function () {
    vueMediumEditor.MediumEditor.extensions.form.prototype.init.apply(this, arguments)

    this.subscribe('editableKeydown', this.handleKeydown.bind(this))
  },

  // Called when the button the toolbar is clicked
  // Overrides ButtonExtension.handleClick
  handleClick: function (event) {
    event.preventDefault()
    event.stopPropagation()

    var range = vueMediumEditor.MediumEditor.selection.getSelectionRange(this.document)

    if (range.startContainer.nodeName.toLowerCase() === 'a' ||
      range.endContainer.nodeName.toLowerCase() === 'a' ||
      vueMediumEditor.MediumEditor.util.getClosestTag(vueMediumEditor.MediumEditor.selection.getSelectedParentElement(range), 'a')) {
      return this.execAction('unlink')
    }

    if (!this.isDisplayed()) {
      this.showForm()
    }

    return false
  },

  // Called when user hits the defined shortcut (CTRL / COMMAND + K)
  handleKeydown: function (event) {
    if (vueMediumEditor.MediumEditor.util.isKey(event, vueMediumEditor.MediumEditor.util.keyCode.K) && vueMediumEditor.MediumEditor.util.isMetaCtrlKey(event) && !event.shiftKey) {
      this.handleClick(event)
    }
  },

  // Called by medium-editor to append form to the toolbar
  getForm: function () {
    if (!this.form) {
      this.form = this.createForm()
    }
    return this.form
  },

  getTemplate: function () {
    var template = []
    // both of these options are slightly moot with the ability to
    // override the various form buildup/serialize functions.
    template.push('<div class="references-and-notes">')
    template.push('<h3>Noter</h3>')
    template.push('<select class="medium-editor-toolbar-notes"><option disabled selected value> -- Välj not -- </option>')
    for (var i = 0; i < this.notes.length; i++) {
      template.push('<option value="' + this.notes[i].name + '">' + this.notes[i].name + '. ' + this.notes[i].text.substring(0, 35) + '...</option>')
    }
    template.push('</select>')
    template.push('<br/>')
    template.push('<input type="checkbox" id="hidenote" checked /><label for="hidenote">Visa enbart i läs mer</label>')
    template.push('<h3>Referenser</h3>')
    template.push('<select class="medium-editor-toolbar-references"><option disabled selected value> -- Välj referens -- </option>')
    for (i = 0; i < this.references.length; i++) {
      template.push('<option value="' + this.references[i].name + '">' + this.references[i].name + '. ' + this.references[i].text.substring(0, 35) + '...</option>')
    }
    template.push('</select>')

    // template.push(
    //   '<div><a href="#" class="medium-editor-toolbar-save">',
    //   this.getEditorOption('buttonLabels') === 'fontawesome' ? '<i class="fa fa-check"></i>' : this.formSaveLabel,
    //   '</a>'
    // )

    // template.push('<a href="#" class="medium-editor-toolbar-close">',
    //   this.getEditorOption('buttonLabels') === 'fontawesome' ? '<i class="fa fa-times"></i>' : this.formCloseLabel,
    //   '</a></div>')
    template.push('</div>')

    return template.join('')
  },

  // Used by medium-editor when the default toolbar is to be displayed
  isDisplayed: function () {
    return vueMediumEditor.MediumEditor.extensions.form.prototype.isDisplayed.apply(this)
  },

  hideForm: function () {
    vueMediumEditor.MediumEditor.extensions.form.prototype.hideForm.apply(this)
  },

  showForm: function (opts) {
    var targetCheckbox = this.getAnchorTargetCheckbox()
    var buttonCheckbox = this.getAnchorButtonCheckbox()

    opts = opts || { value: '' }
    // TODO: This is for backwards compatability
    // We don't need to support the 'string' argument in 6.0.0
    if (typeof opts === 'string') {
      opts = {
        value: opts
      }
    }

    this.base.saveSelection()
    this.hideToolbarDefaultActions()
    vueMediumEditor.MediumEditor.extensions.form.prototype.showForm.apply(this)
    this.setToolbarPosition()

    // If we have a target checkbox, we want it to be checked/unchecked
    // based on whether the existing link has target=_blank
    if (targetCheckbox) {
      targetCheckbox.checked = opts.target === '_blank'
    }

    // If we have a custom class checkbox, we want it to be checked/unchecked
    // based on whether an existing link already has the class
    if (buttonCheckbox) {
      var classList = opts.buttonClass ? opts.buttonClass.split(' ') : []
      buttonCheckbox.checked = (classList.indexOf(this.customClassOption) !== -1)
    }
  },

  // Called by core when tearing down medium-editor (destroy)
  destroy: function () {
    if (!this.form) {
      return false
    }

    if (this.form.parentNode) {
      this.form.parentNode.removeChild(this.form)
    }

    delete this.form
  },

  // core methods

  getFormOpts: function (value, className) {
    if (value && className) {
      return { value: value, buttonClass: className, target: '_self' }
    }
    // no notion of private functions? wanted `_getFormOpts`
    var targetCheckbox = this.getAnchorTargetCheckbox()
    var buttonCheckbox = this.getAnchorButtonCheckbox()
    var opts = {
      value: 'this.getInput().value.trim()'
    }

    if (this.linkValidation) {
      opts.value = this.checkLinkFormat(opts.value)
    }

    opts.target = '_self'
    if (targetCheckbox && targetCheckbox.checked) {
      opts.target = '_blank'
    }

    if (buttonCheckbox && buttonCheckbox.checked) {
      opts.buttonClass = this.customClassOption
    }

    return opts
  },

  doFormSave: function (value, className) {
    var opts = this.getFormOpts(value, className)
    this.completeFormSave(opts)
  },

  completeFormSave: function (opts) {
    this.base.restoreSelection()
    this.execAction(this.action, opts)
    this.base.checkSelection()
  },

  ensureEncodedUri: function (str) {
    return str === decodeURI(str) ? encodeURI(str) : str
  },

  ensureEncodedUriComponent: function (str) {
    return str === decodeURIComponent(str) ? encodeURIComponent(str) : str
  },

  ensureEncodedParam: function (param) {
    var split = param.split('=')
    var key = split[0]
    var val = split[1]

    return key + (val === undefined ? '' : '=' + this.ensureEncodedUriComponent(val))
  },

  ensureEncodedQuery: function (queryString) {
    return queryString.split('&').map(this.ensureEncodedParam.bind(this)).join('&')
  },

  checkLinkFormat: function (value) {
    // Matches any alphabetical characters followed by ://
    // Matches protocol relative "//"
    // Matches common external protocols "mailto:" "tel:" "maps:"
    // Matches relative hash link, begins with "#"
    var urlSchemeRegex = /^([a-z]+:)?\/\/|^(mailto|tel|maps):|^#/i
    var hasScheme = urlSchemeRegex.test(value)
    var scheme = ''
      // telRegex is a regex for checking if the string is a telephone number
    var telRegex = /^\+?\s?\(?(?:\d\s?-?\)?){3,20}$/
    var urlParts = value.match(/^(.*?)(?:\?(.*?))?(?:#(.*))?$/)
    var path = urlParts[1]
    var query = urlParts[2]
    var fragment = urlParts[3]

    if (telRegex.test(value)) {
      return 'tel:' + value
    }

    if (!hasScheme) {
      var host = path.split('/')[0]
      // if the host part of the path looks like a hostname
      if (host.match(/.+(\.|:).+/) || host === 'localhost') {
        scheme = 'http://'
      }
    }

    return scheme +
        // Ensure path is encoded
        this.ensureEncodedUri(path) +
        // Ensure query is encoded
        (query === undefined ? '' : '?' + this.ensureEncodedQuery(query)) +
        // Include fragment unencoded as encodeUriComponent is too
        // heavy handed for the many characters allowed in a fragment
        (fragment === undefined ? '' : '#' + fragment)
  },

  doFormCancel: function () {
    this.base.restoreSelection()
    this.base.checkSelection()
  },

  // form creation and event handling
  attachFormEvents: function (form) {
    var notes = form.querySelector('.medium-editor-toolbar-notes')
    var references = form.querySelector('.medium-editor-toolbar-references')

    // Handle clicks on the form itself
    this.on(form, 'click', this.handleFormClick.bind(this))

    // Custom notes and references
    this.on(notes, 'change', this.handleNoteChange.bind(this))
    this.on(references, 'change', this.handleReferenceChange.bind(this))
  },

  createForm: function () {
    var doc = this.document
    var form = doc.createElement('div')

    // Anchor Form (div)
    form.className = 'medium-editor-toolbar-form'
    form.id = 'medium-editor-toolbar-form-anchor-' + this.getEditorId()
    form.innerHTML = this.getTemplate()
    this.attachFormEvents(form)

    return form
  },

  getAnchorTargetCheckbox: function () {
    return this.getForm().querySelector('.medium-editor-toolbar-anchor-target')
  },

  getAnchorButtonCheckbox: function () {
    return this.getForm().querySelector('.medium-editor-toolbar-anchor-button')
  },

  handleTextboxKeyup: function (event) {
    // For ENTER -> create the anchor
    if (event.keyCode === vueMediumEditor.MediumEditor.util.keyCode.ENTER) {
      event.preventDefault()
      this.doFormSave()
      return
    }

    // For ESCAPE -> close the form
    if (event.keyCode === vueMediumEditor.MediumEditor.util.keyCode.ESCAPE) {
      event.preventDefault()
      this.doFormCancel()
    }
  },

  handleFormClick: function (event) {
    // make sure not to hide form when clicking inside the form
    event.stopPropagation()
  },

  handleSaveClick: function (event) {
    // Clicking Save -> create the anchor
    event.preventDefault()
    this.doFormSave()
  },

  handleCloseClick: function (event) {
    // Click Close -> close the form
    event.preventDefault()
    this.doFormCancel()
  },

  handleNoteChange: function (event) {
    var selectBox = document.getElementsByClassName('medium-editor-toolbar-notes')
    var selectedValue = selectBox[0].options[selectBox[0].selectedIndex].value
    var hideNoteCheckbox = document.getElementById('hidenote')
    var hideNote = hideNoteCheckbox.checked
    var classText = 'note'
    if (hideNote) {
      classText += ' hide'
    }
    event.preventDefault()
    this.doFormSave(selectedValue, classText)
  },

  handleReferenceChange: function (event) {
    var selectBox = document.getElementsByClassName('medium-editor-toolbar-references')
    var selectedValue = selectBox[0].options[selectBox[0].selectedIndex].value
    event.preventDefault()
    this.doFormSave(selectedValue, 'reference')
  }
})
